import { API } from './api';

interface SearchStore {
  baseUrlApi?: string | { value: string };
  lang?: string;
}

interface SearchParams {
  token?: string;
  q?: string;
  offset?: number;
  amount?: number;
  [key: string]: any;
}

class SearchService extends API {
  constructor(store?: SearchStore, params?: SearchParams) {
    super(store, params);
  }

  override generateUrl(): string {
    return this.generateSearchResultsUrl();
  }

  generateSearchResultsUrl(): string {
    const q = encodeURIComponent((this.params as SearchParams)?.q || '');
    const token = (this.params as SearchParams)?.token || '';
    const offset = Number.isInteger((this.params as SearchParams)?.offset) ? (this.params as SearchParams)!.offset : 0;
    const amount = Number.isInteger((this.params as SearchParams)?.amount) ? (this.params as SearchParams)!.amount : 50;
    const lang = (this.store as SearchStore)?.lang || 'da';
    return ['search/', lang, '/', String(offset), '/', String(amount), '?q=', q, '&token=', token].join('');
  }

  async getSearchResults(): Promise<any> {
    return await this.fetchData();
  }
}

export default SearchService;
export { SearchService };
